/* eslint-disable spellcheck/spell-checker */

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { NanoPlayerComponent } from './nano-player/nano-player.component';

@Component({
    selector: 'app-streaming-video',
    standalone: true,
    imports: [CommonModule, NanoPlayerComponent],
    templateUrl: './streaming-video.component.html',
    styleUrl: './streaming-video.component.scss'
})
export class StreamingVideoComponent implements OnInit {
    @Input()
    videoEnabled = false;

    @Input()
    streamId?: string;

    @Output()
    readonly toggleClicked = new EventEmitter<void>();

    protected config!: object;

    ngOnInit(): void {
        if (!this.streamId) {
            // eslint-disable-next-line no-console
            console.error('streamId not provided');
            return;
        }

        this.config = this.buildNanoPlayerConfig(this.streamId);
    }

    private buildNanoPlayerConfig(streamId: string): object {
        return {
            source: {
                entries: [
                    {
                        bintu: {
                            streamid: streamId
                        }
                    }
                ]
            }
        };
    }
}
